<template>
    <div>
        <div v-if="orderList.length==0" style="text-align: center;padding:1rem 0;">
            您还木油下单哇~~~<br /><br /><br />
            <yd-button size="large" bgcolor="#FFD000" color="#333333" type="primary" @click.native="closePage" shape="circle" style="width:60%;margin-left:20%; margin-top:.6rem;">返 回</yd-button>
        </div>
        <div class="order-item" v-for="order in orderList">
            <yd-flexbox>
                <yd-flexbox-item>订单号:{{order.trade_no}}</yd-flexbox-item>
                <div class="curr">{{order.status != 0 ? '已发货':'待发货'}}</div>
            </yd-flexbox>
            <yd-flexbox style="padding:.1rem 0;">
                <yd-flexbox-item>
                    商品名称<br />
                    <span class="large">{{order.name}}</span>
                </yd-flexbox-item>
                <div style="width:7em;">
                    价格<br />
                    <span class="large curr price">{{order.pay}}</span>
                </div>
            </yd-flexbox>
            <div style="padding:.1rem 0;">
                赠品 <span class="curr"> 已发放 </span> <br />
                <p>{{order.gift_info}}</p>
            </div>
            <div style="padding:.1rem 0;">
                所选茶叶 <br />
                <p>{{order.goods_info}}</p>
            </div>
            <yd-flexbox style="padding:.1rem 0;">
                <yd-flexbox-item>
                    <div v-if="order.tracking_no">
                        快递公司：{{order.tracking_com}} <br />
                        快递单号：{{order.tracking_no}}
                    </div>
                </yd-flexbox-item>
                <div style="font-size:.8em;">{{order.addtime}}</div>
            </yd-flexbox>
        </div>
    </div>
</template>

<script>
    import { fetch,post } from '@/api/appRequest.js'
    export default {
        name: "teaOrder",
        data(){
            return {
                orderList:[]
            };
        },
        created() {
            this.$dialog.loading.open('正在加载订单列表...');
            fetch('order_list', {skip:0, limit:20}).then(res=>{
                this.$dialog.loading.close();
                if (res.status_code == 200) {
                    this.orderList = JSON.parse(decodeURIComponent(res.data).replace(/\+/g,' '));
                }
            }).catch(err=>{
                this.$dialog.alert({mes:'获取订单失败!'});
            });
        },
        methods:{
            closePage(){
                this.$yymd.close();
            },
        }
    }
</script>

<style>
    html,body {background-color:#F7F7F7;}
</style>
<style scoped>
    .large {font-size:2em; font-weight: 900; color:#333333;line-height: 1.5em;}
    .price:before{content:'￥'; font-size:.6em;}
    .curr {color:#F17B7B; font-size:.8em;}
    .price {font-size:1.6em;}
    .order-item {
        color:#AAAAAA; line-height: 1.6em;
        background-color:#fff;margin:.2rem; border-radius: .2rem;
        padding:.2rem;
    }
    .order-item p {color:#333333;}
</style>